<template>
  <router-view v-if="hideLayout" />
  <div v-else-if="canRenderProtectedLayout" class="min-h-screen">
    <AppSidebar :open="sidebarOpen" @close="sidebarOpen = false" />
    <button v-if="sidebarOpen" class="sidebar-backdrop" type="button" aria-label="Fechar menu" @click="sidebarOpen = false" />
    <div class="gp-main min-h-screen lg:pl-72">
      <AppHeader
        :user-name="userName"
        :title="headerTitle"
        :subtitle="headerSubtitle"
        @toggle-menu="sidebarOpen = !sidebarOpen"
        @logout="logout"
      />
      <main class="px-4 py-7 sm:px-6 lg:px-8">
        <router-view :user-name="userName" />
      </main>
    </div>
  </div>
  <main v-else class="auth-redirect-page" aria-live="polite" aria-busy="true">
    <span class="auth-redirect-spinner" aria-hidden="true" />
    <span>Redirecionando para a autenticação...</span>
  </main>
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import AppSidebar from './components/AppSidebar.vue'
import authService from './auth/oidc'

export default {
  name: 'App',
  components: { AppHeader, AppSidebar },
  data: () => ({
    sidebarOpen: false,
    userName: 'Usuário',
    authResolved: false,
    authenticated: false
  }),
  computed: {
    hideLayout () {
      return Boolean(this.$route.meta.hideLayout)
    },
    headerTitle () {
      return this.$route.meta.headerTitle || 'Sistema Financeiro'
    },
    headerSubtitle () {
      return this.$route.meta.headerSubtitle || 'GarantePay'
    },
    canRenderProtectedLayout () {
      return this.authResolved && this.authenticated
    }
  },
  watch: {
    '$route.fullPath' () {
      this.sidebarOpen = false
      this.loadUser()
    }
  },
  mounted () {
    this.loadUser()
  },
  methods: {
    async loadUser () {
      try {
        const user = await authService.getUser()
        this.authenticated = Boolean(user && !user.expired && user.access_token)
        this.userName = user?.profile?.name || user?.profile?.CusNome || 'Usuário'
      } catch (_) {
        this.authenticated = false
        this.userName = 'Usuário'
      } finally {
        this.authResolved = true
      }
    },
    async logout () {
      await authService.signOutRedirect()
    }
  }
}
</script>
